const JWT_SESSION_KEY = "atlassian_jwt";

class JWTStore {

    private static _instance: JWTStore;
    private backupJwt: string = "";

    private constructor()  {
    }

    public static get instance()
    {
        return this._instance || (this._instance = new this());
    }

    get jwt(): string {
        try {
            let jwt = window.sessionStorage.getItem(JWT_SESSION_KEY);
            if(!jwt) {
                throw new Error("jwt is not available");
            }
            return jwt;
        } catch (error) {
            return this.backupJwt;
        }
    }

    set jwt(value: string) {
        try {
            window.sessionStorage.setItem(JWT_SESSION_KEY, value);
        } catch (error) {
            this.backupJwt = value;
        }
    }
}

export const jwtstore:JWTStore = JWTStore.instance;
